import { render, staticRenderFns } from "./ClientsPersonsFilesTab.vue?vue&type=template&id=098eb18c&scoped=true&"
import script from "./ClientsPersonsFilesTab.vue?vue&type=script&lang=js&"
export * from "./ClientsPersonsFilesTab.vue?vue&type=script&lang=js&"
import style0 from "./ClientsPersonsFilesTab.vue?vue&type=style&index=0&id=098eb18c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "098eb18c",
  null
  
)

export default component.exports